import styled, { useTheme } from 'styled-components';
import ItemTable from '../../../components/ItemTable';
import { Button, Subtitle } from '../../../components/ui';
import CheckoutProgressbar from '../../../components/CheckoutProgressbar';

const MainContainer = styled.div`
  display: flex;
  width: 100%;
  max-width: 1450px;
  gap: 1.5rem;
  margin-top: 0;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
    margin-top: 0;
  }

  @media (max-width: 480px) {
    gap: 0.5rem;
    margin-top: 0;
  }
`;

const LeftSection = styled.div`
  display: flex;
  flex-direction: column;
  flex: 2.5;
  gap: 1rem;
  max-width: 1600px;
  min-width: 0;
  overflow: hidden;

  @media (max-width: 768px) {
    gap: 0.8rem;
    max-width: none;
    overflow: visible;
  }

  @media (max-width: 480px) {
    gap: 0.5rem;
  }
`;

const RightSection = styled.div`
  display: flex;
  flex: 0.6;
  flex-direction: column;
  gap: 1rem;
  min-width: 0;
  align-self: flex-start;
  position: sticky;
  top: 20px;

  @media (max-width: 768px) {
    gap: 0.8rem;
    position: static;
  }

  @media (max-width: 480px) {
    gap: 0.5rem;
    position: static;
  }
`;

const Row = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
  }

  @media (max-width: 480px) {
    gap: 0.5rem;
  }
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  gap: 10px;
  box-sizing: border-box;

  @media (max-width: 768px) {
    gap: 8px;
  }

  @media (max-width: 480px) {
    gap: 5px;
  }
`;

const TotalBox = styled.div`
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 30px;
  border-radius: 10px;
  background: ${(props) => props.theme.colors.subBackground};
  padding: 10% 20px;
  font-size: 18px;
  font-weight: bold;
  text-align: right;
  box-sizing: border-box;

  @media (max-width: 768px) {
    gap: 20px;
    padding: 15px;
    font-size: 16px;
  }

  @media (max-width: 480px) {
    gap: 15px;
    padding: 10px;
    font-size: 14px;
  }
`;

const ConfirmView = ({
  cartList,
  setCurrentStep,
  shipToInfo,
  paymentInfo,
  billToInfo,
  handlePlaceOrder,
  totalItemPrice,
  totalTaxPrice,
  totalShippingPrice,
  totalPrice,
}) => {
  const theme = useTheme();

  return (
    <MainContainer>
      <LeftSection>
        <ItemTable data={cartList} showDeleteBtn={false} editable={false} />
      </LeftSection>
      <RightSection>
        <Subtitle
          color={theme.colors.primaryRed}
          style={{ textAlign: 'center', marginBottom: '20px' }}
        >
          Shipping fee will be added to invoice when order is ready to be
          shipped.
        </Subtitle>
        <Column style={{ gap: '1rem' }}>
          <TotalBox>
            <Column>
              <Row style={{ justifyContent: 'space-between' }}>
                <Subtitle>Total:</Subtitle>
                <Subtitle>{`$${parseFloat(totalItemPrice).toFixed(2)}`}</Subtitle>
              </Row>
              <Row style={{ justifyContent: 'space-between' }}>
                <Subtitle>Tax:</Subtitle>
                <Subtitle>{`$${parseFloat(totalTaxPrice).toFixed(2)}`}</Subtitle>
              </Row>
              <Row style={{ justifyContent: 'space-between' }}>
                <Subtitle>Shipping:</Subtitle>
                <Subtitle>{`$${parseFloat(totalShippingPrice).toFixed(2)}`}</Subtitle>
              </Row>
              <Row style={{ justifyContent: 'space-between' }}>
                <Subtitle weight='bold' size='1.1rem'>
                  Total:
                </Subtitle>
                <Subtitle weight='bold' size='1.1rem'>
                  {`$${parseFloat(totalPrice).toFixed(2)}`}
                </Subtitle>
              </Row>
            </Column>
          </TotalBox>
          <Button
            style={{
              width: '100%',
              marginTop: '1.5rem',
              opacity: 1,
            }}
            onClick={handlePlaceOrder}
          >
            Place an order
          </Button>
        </Column>
      </RightSection>
    </MainContainer>
  );
};

export default ConfirmView;
